import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "../Assets/Company_Logo2.png";

export default function Header() {

  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {

    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);


  const navItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Contact", path: "/contact" }
  ];


  return (

    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}

      className={`fixed top-0 w-full z-50 transition-all duration-300
      ${scrolled
        ? "bg-white shadow-md border-b border-gray-200"
        : "bg-white"
      }`}
    >

      <div className="max-w-7xl mx-auto px-6">

        <div className="flex items-center justify-between h-20">


          {/* LOGO */}

          <Link to="/" className="flex items-center">

            <img
              src={Logo}
              alt="HR Consultancy"
              className="h-16 w-16 object-contain"
            />

          </Link>



          {/* DESKTOP NAV */}

          <nav className="hidden md:flex items-center gap-10">

            {navItems.map((item) => (

              <Link
                key={item.name}
                to={item.path}

                className="text-gray-700 font-medium text-sm relative group hover:text-black transition"
              >

                {item.name}

                <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-black transition-all duration-300 group-hover:w-full"></span>

              </Link>

            ))}

          </nav>



          {/* CTA BUTTON */}

          <Link to="/contact">

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}

              className="hidden md:block px-6 py-2 border border-black text-black font-medium text-sm hover:bg-black hover:text-white transition"
            >
              Get Consultation
            </motion.button>

          </Link>



          {/* MOBILE MENU BUTTON */}

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-black"
          >

            {isOpen ? <X size={26} /> : <Menu size={26} />}

          </button>

        </div>

      </div>



      {/* MOBILE MENU */}

      <AnimatePresence>

        {isOpen && (

          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}

            className="md:hidden bg-white border-t border-gray-200"
          >

            <div className="flex flex-col px-6 py-6 gap-4">

              {navItems.map((item) => (

                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsOpen(false)}

                  className="text-gray-700 hover:text-black transition"
                >

                  {item.name}

                </Link>

              ))}

              <Link
                to="/contact"
                onClick={() => setIsOpen(false)}
                className="mt-2 px-6 py-2 border border-black text-center font-medium hover:bg-black hover:text-white transition"
              >
                Get Consultation
              </Link>

            </div>

          </motion.div>

        )}

      </AnimatePresence>

    </motion.header>

  );

}